import { render, staticRenderFns } from "./AffiliationPersonalization.vue?vue&type=template&id=1a78c48b&scoped=true"
import script from "./AffiliationPersonalization.vue?vue&type=script&lang=js"
export * from "./AffiliationPersonalization.vue?vue&type=script&lang=js"
import style0 from "./AffiliationPersonalization.vue?vue&type=style&index=0&id=1a78c48b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a78c48b",
  null
  
)

export default component.exports